import { render, staticRenderFns } from "./OrganisationPermissions.vue?vue&type=template&id=6ad76f77&scoped=true&"
import script from "./OrganisationPermissions.vue?vue&type=script&lang=js&"
export * from "./OrganisationPermissions.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationPermissions.vue?vue&type=style&index=0&id=6ad76f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad76f77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VLayout,VTooltip})
